/* unplugin-vue-components disabled */import { render } from "./IndexLayout.vue?vue&type=template&id=1ae54883&scoped=true&lang=pug"
import script from "./IndexLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexLayout.vue?vue&type=script&setup=true&lang=js"

import "./IndexLayout.vue?vue&type=style&index=0&id=1ae54883&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae54883"]])

export default __exports__